import React from 'react';

import Detail from 'ROOT/views/portal/components/detailView/detail';
import ActivitiesTimeline from 'ROOT/src/components/RightPanel/ActivitiesTimeline/ActivitiesTimeline';
import ViewPanelMenu from 'ROOT/src/components/viewPanelMenu/viewPanelMenu';
import ProductSelector from 'ROOT/src/components/RightPanel/Quotes/productSelector';
import MassUpdateContent from 'ROOT/src/components/RightPanel/MassUpdate/MassUpdateContent';
import EmailDetail from 'ROOT/src/components/email/EmailDetail';
import EmailDetailHeader from 'ROOT/src/components/email/EmailDetailHeader';
import ListViewSearch from 'ROOT/src/components/list/ListViewSearch.js';

import Error from 'ROOT/src/components/Errors/ErrorView';
import Subpanels from 'ROOT/src/components/subpanel/Subpanels';
import Loader from 'ROOT/src/components/loader';

import RightPanelImage from './RightPanelImage';
import RightPanelVideo from 'ROOT/src/components/RightPanel/RightPanelVideo';
import RightPanelPDF from 'ROOT/src/components/RightPanel/RightPanelPDF.js/RightPanelPDF';
import RightPanelWord from 'ROOT/src/components/RightPanel/RightPanelWord';
import RightPanelExcel from 'ROOT/src/components/RightPanel/RightPanelExcel';

import RightPanel_orig from 'ROOT/src/components/RightPanel/RightPanel';
import sAction from 'sAction';
import classNames from 'classnames';

export default class RightPanel extends RightPanel_orig {
    getHeader() {
        const data = this.props.data?.data;
        const downloadFn = data?.get('downloadFn');
        let fileName = '';

        if (data.get('module') && data.get('id')) {
            fileName = this.getFilename();
        }

        if (downloadFn) {
            return (
                <div className="rightPanelHeaderContent">
                    <div className="rightPanelHeaderContentTitle">
                        {fileName}
                    </div>
                    <div className="rightPanelHeaderContentActions">
                        <div className="rightPanelHeaderActionsDownload icon-download" onClick={() => downloadFn()} >
                            <span className='downloadBtnText'>{sAction.translate('LBL_DOWNLOAD_FILE')}</span>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }

    getFilename() {
        const data = this.props.data?.data;
        const listRows = sAction.dataGet('view/rows');

        // find row with key NAME
        const nameRow = listRows?.find((row) => row.get('key') === 'NAME');

        if (nameRow) {
            const records = nameRow.get('records');
            // find record where id is equal to id from data
            const name = records.find((record) => record.get('id') === data.get('id')).get('value');
            return name;
        }
    }

    render() {
        const data = this.props.data;
        let content = data.content;
        let headerContent = null;

        switch (content) {
            case 'load':
                content = <Loader />;
                break;
            case 'detailView':
                content = (
                    <Detail
                        key="detail"
                        a={this.props.action}
                        data={data.data.get('detail')}
                        way="rightPanel/data/detail"
                    />
                );
                headerContent = <React.Fragment>
                    <ViewPanelMenu data={data.data.get('detail')} prefix="rightPanel/data/detail" />
                    <div className="rightPanelClose icon-expandIcon"
                        onClick={() => this.openRecord(data.data.getIn(['detail', 'module']), data.data.getIn(['detail', 'id']))}></div>
                </React.Fragment>;
                break;
            case 'productView':
                headerContent = (
                    <div className="productSelectorListViewSearchContainer">
                        <ListViewSearch prefix="rightPanel/data/listView" data={data.data.listView.filter} />
                    </div>
                );

                content = (
                    <ProductSelector data={data.data} detailWay="view" />
                );
                break;

            case 'emailRelations':
                content = (
                    <div className="email__relations">
                        <Subpanels data={data.data.get('detail').subpanels} way="rightPanel/data/detail" />
                    </div>
                );
                break;
            case 'emailView':
                content = (
                    <div className="emailRightPanelContainer">
                        <EmailDetail data={data.data} hideHeader />
                    </div>
                );
                headerContent = (
                    <EmailDetailHeader data={data.data} />
                );
                break;
            case 'massUpdateView':
                content = (
                    <MassUpdateContent data={data.data} />
                );
                break;
            case 'activitiesTimelineView':
                const activitiesTimelinePrefix = 'rightPanel';
                content = (<ActivitiesTimeline prefix={activitiesTimelinePrefix+'/data'} data={data.data}/>);
                break;
            case 'error':
                content = (<Error data={data.data}/>);
                break;
            case 'image':
                content = (<RightPanelImage data={data.data} />);
                headerContent = this.getHeader();
                break;
            case 'pdf':
                content = (<RightPanelPDF data={data.data} />);
                headerContent = this.getHeader();
                break;
            case 'mp4':
                content = (<RightPanelVideo data={data.data} />);
                headerContent = this.getHeader();
                break;
            case 'docx':
                content = (<RightPanelWord data={data.data} />);
                headerContent = this.getHeader();
                break;
            case 'xlsx':
                content = (<RightPanelExcel data={data.data} />);
                headerContent = this.getHeader();
                break;
        }


        // if (conf.alertMessage.get('show')) {
        //     pageClass += ' alertMessageActive';
        // }

        return (
            <div
                className={classNames('rightPanelContainer', {'alertMessageActive': this.props?.conf?.alertMessage?.get('show')})}
                ref={this.panel}
            >
                <div className="rightPanelHeader">
                    <div
                        className="icon-Close rightPanelClose"
                        onClick={() => this.close()}
                    />
                    {headerContent}
                </div>
                <div className="rightPanelContent">{content}</div>
            </div>
        );
    }
}
